import { render, staticRenderFns } from "./ConvenioImportPage.vue?vue&type=template&id=290371cd&scoped=true"
import script from "./ConvenioImportPage.vue?vue&type=script&lang=js"
export * from "./ConvenioImportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290371cd",
  null
  
)

export default component.exports